import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC996SDxPhgHoswXZXMu8Drl92thrApZWY",
  authDomain: "ibhava.firebaseapp.com",
  projectId: "ibhava",
  storageBucket: "ibhava.firebasestorage.app",
  messagingSenderId: "347781823520",
  appId: "1:347781823520:web:58ac27c0ed0489b33c5045",
  measurementId: "G-0W88F84ZG6",
};

const app = initializeApp(firebaseConfig);

if (window.location.hostname === "localhost") {
  var authFirebase = getAuth();
  connectAuthEmulator(authFirebase, "http://localhost:9099");
  var dbFirebase = getFirestore();
  connectFirestoreEmulator(dbFirebase, "localhost", 8080);
  var storageFirebase = getStorage();
  connectStorageEmulator(storageFirebase, "localhost", 9199);
} else {
  authFirebase = getAuth(app);
  dbFirebase = getFirestore(app);
  storageFirebase = getStorage(app);
}

export const storage = storageFirebase;
export const auth = authFirebase;
export const db = dbFirebase;
export const googleProvider = new GoogleAuthProvider();
